import { render, staticRenderFns } from "./course-info.vue?vue&type=template&id=5be43836&scoped=true&"
import script from "./course-info.vue?vue&type=script&lang=js&"
export * from "./course-info.vue?vue&type=script&lang=js&"
import style0 from "./course-info.vue?vue&type=style&index=0&id=5be43836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be43836",
  null
  
)

export default component.exports